var map = {
	"./LogAddUserBalance.vue": [
		2523,
		2523
	],
	"./LogStatisticsOilStation.vue": [
		1351,
		1351
	],
	"./LogUserBalance.vue": [
		352,
		352
	],
	"./LogUserPoints.vue": [
		180,
		180
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 8858;
module.exports = webpackAsyncContext;